import { Skeleton } from "primereact/skeleton";
import { PathCard } from "sj-ui-toolkit/src/atlas/components/ContentCard/PathCard/PathCard";

const loadingSkeleton = Array.from({ length: 4 }, (_, i) => `skelly-${i}`);

export const BucketOfLearninRow = ({
  loading,
  name,
  description,
  id,
  learnins,
  variant,
  pathType,
}) => {
  if (learnins?.error) {
    return null;
  }

  const isQuest = pathType === "Quest";
  const isLoading = loading && learnins === undefined;

  // Remove Rows with no available paths
  if (!isLoading && learnins?.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <h2 className={"atlas-h5 pb-2"}>{name}</h2>
      {description && <p>{description}</p>}
      <div className="overflow-x-auto flex gap-6 py-6">
        {isLoading ? (
          <>
            {loadingSkeleton.map(skel => (
              <Skeleton key={`${id}-${skel}`} width="300px" height="400px" className="mr-6" />
            ))}
          </>
        ) : (
          <>
            {learnins?.map(learnin => (
              <PathCard
                key={learnin.id}
                cardSize="small"
                variant={variant}
                id={isQuest ? learnin.role?.id : learnin.id}
                name={learnin.name}
                description={learnin.description}
                pathType={pathType}
                status={learnin.status}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
